// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/Locations/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Settings_Locations{
  session_user_locations(order_by: { name: asc }) {
    id
    _id
    text: name
  }
}

`